export default function Videos() {
    return <h1>Videos</h1>;
  }